import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])
export const pageSearch = {
  'makDate': {
    title: '开票日期',
    type: 'date',
    equation: all,
    defaultOption: "GE",
    defaultVal: '2022-11-26',
  },
  'zzfld000001': {
    describe: true, // 描述 _text 添加属性
    suffix: 'TextView',
    title: '营销单元', // 字段名称
    type: 'select', // 输入类型 下拉
    equation: all, // 条件
    defaultOption: "NE", //默认选择条件
    defaultVal: '0005000172', //默认值
    dictionary: 'sale' // 字典 （营销单元(sale)， 基地(base)，省(region)，市(city)，区(street)）
  },
  'orderCustomerName': {
    title: '订单客户名称',
    type: 'input',
    width: 200
  },
  'brandBq': {
    title: '存货分类',
    describe: true,
    suffix: 'TextView',
    type: 'select',
    equation: city,
    dictionary: 'A0019',
    width: 200
  },
}
export default {
  'invoicingCustomer': {
    title: '开票客户编码'
  },
  'invoicingCustomerName': {
    title: '开票客户名称',
    width: 200
  },
  'billCustomerType': {
    describe: true,
    title: '开票客户类型',
    suffix: 'TextView',
    type: 'select',
    equation: city,
    dictionary: 'A0009'
  },
  'orderCustomer': {
    title: '订单客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '订单客户'
    }
  },
  'orderCustomerName': {
    title: '订单客户名称',
    width: 200
  },
  'orderCustomerType': {
    describe: true,
    title: '订单客户类型',
    suffix: 'TextView',
    type: 'select',
    equation: city,
    dictionary: 'A0009'
  },
  'zzfld000001TextView': {
    title: '营销单元', // 字段名称
  },
  /* 'salesCenterTextView': {
    title: '营销单元',
    equation: city, // 条件
    width: 150
  },*/
  'zzfld00002q': {
    describe: true, // 描述 _text 添加属性
    suffix: 'TextView',
    title: '计划类型',
    width: 150,
    type: 'select',
    dictionary: 'A0002'
  },
  'brandBqTextView': {
    title: '存货分类',
  },
  'description': {
    title: '产品名称',
    type: 'input',
    width: 300
  },
  'province': {
    title: '省',
    type: 'select',
    equation: city,
    dictionary: 'region'
  },
  'city': {
    title: '市',
    type: 'select',
    equation: city,
    dictionary: 'city'

  },
  'invType': {
    describe: true,
    title: '发票类型',
    suffix: 'TextView',
    type: 'select',
    equation: city,
    dictionary: 'A0032'
  },
  'invProperty': {
    describe: true,
    suffix: 'TextView',
    title: '发票性质',
    type: 'select',
    equation: city,
    dictionary: 'inv_property'
  },
  'invoId': {
    title: '发票号',
    type: 'input',
  },
  'manualInvo': {
    type: 'input',
    title: '提货票'
  },
  'usequantity': {
    title: '开票量(瓶)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'usezzfld9': {
    title: '开票量(件)',
    xlsxFmt: {
      t: 'n'
    }
  },

  'transferqty': {
    title: '货权转移量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'approvingnum': {
    title: '正在审批量',
    xlsxFmt: {
      t: 'n'
    }

  },
  'usednum': {
    title: '已审批量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'occupancynum': {
    title: '已占用量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remainnum': {
    title: '剩余量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'makDate': {
    title: '开票日期',
    equation: all
  },
  'isClear': {
    describe: true,
    suffix: 'TextView',
    title: '是否结清',
    type: 'select',
    dictionary: 'isClear',
    dictionaryVal: [
      { name: '是', value: '1' },
      { name: '否', value: '0' }
    ]
  },
  'annual': {
    title: '配额年度'
  },
  'wInvoInfoid': {
    title: '外部通知单号'
  },
  'numberInt': {
    title: '行号'
  },
  'objectId': {
    title: '销售订单号'
  },
  'netPrice': {
    title: '含税单价',
    slot: true,
    xlsxFmt: {
      t: 'n',
      z: '0.00'
    }
  },
  'actualUsequantity、”': {
    title: '实际开票(瓶)'
  },
  'actualUsezzfld9': {
    title: '实际开票(件)'
  },
  'tons': {
    title: '开票吨数',
    slot: true,
     xlsxFmt: {
      t: 'n',
      z: '0.00'
    }
  },
  'totalTax': {
    title: '价税合计(折扣后)',
    slot: true,
    xlsxFmt: {
      t: 'n',
      z: '0.00'
    }
  },
  'netValue': {
    title: '价税合计(折扣前)',
    slot: true,
    xlsxFmt: {
      t: 'n',
      z: '0.00'
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/report-forms-manage/config/dealersMakeInvoiceUsedReportForms.js